<!-- NewComponent.vue -->
<script setup lang="ts">
import ISolveIcon from "@/components/ISolveIcon.vue";
import MpdSwiper from "@/components/MpdSwiper.vue";
const router = useRouter()

import Button from '@/components/Button.vue'

import ProductCardMega from "@/components/cards/ProductCardMega.vue";
import { vwWithMax } from '@/utility/utility';


const productCard = ProductCardMega; // resolveComponent('ProductCardMega')

function redirect(path: string) {
  router.push(path)
  console.log('redirect', path)
}

const MenuItems = ref([
  {
    slug: 'featured',
    label: 'Featured',
    description: 'Our established and trusted favourites',
  },
  {
    slug: 'ethanol',
    label: 'Ethanol Blending',
    description: 'Our trademark ethanol blending solutions',
  },
  {
    slug: 'essential-chemicals',
    label: 'Essential Chemicals',
    description: 'Blended building blocks for your products',
  },
  {
    slug: 'manufactured-products',
    label: 'Manufactured Products',
    description: 'Our range of manufactured products',
  },
])

const activeMenu = ref<{
  slug: string
  label: string
}>({
  slug: 'featured',
  label: 'Featured',
})

const { $content, $io } = useNuxtApp()

const products = computed(() => {
  const records = $content.content?.product?.records
  if (Array.isArray(records) && records.length > 0) {
    return records
  }
  return []
})

const $products = ref([])

async function setProducts() {

  if(!activeMenu.value) {
    return
  }

  if(!Array.isArray(products.value) || products.value.length === 0) {
    return
  }

  if (activeMenu.value.slug === 'featured') {
    $products.value = products.value.slice(0, 3)
  } else if (activeMenu.value.slug === 'ethanol') {
    $products.value = products.value.filter((product) => product.category === 'ethanol').slice(0, 3)
  } else if (activeMenu.value.slug === 'essential-chemicals') {
    $products.value = products.value.filter((product) => product.category === 'essential-chemicals').slice(0, 3)
  } else if (activeMenu.value.slug === 'manufactured-products') {
    $products.value = products.value.filter((product) => product.category === 'manufactured-products').slice(0, 3)
  } else {
    $products.value = []
  }

   // Force Swiper to update after reactivity is applied
  await nextTick();
  if (swiperComponent.value && typeof swiperComponent.value.update === 'function') {
    swiperComponent.value.update();
  }
}


watch(products, async (products, oldVal) => { // Corrected parameter order
  if(Array.isArray(products) && products.length > 0) {
    setProducts()
  }
}, {
  immediate: true
})
watch(activeMenu, async (newVal, oldVal) => { // Corrected parameter order
  if(Array.isArray(products.value) && products.value.length > 0) {
    setProducts()
  }
}, {
  immediate: true
})


const swiper = ref()

function onSlideChange() {
  // console.log('onSlideChange')
}

function onSwiper(swiper: any) {
  // console.log('onSwiper', swiper)
  if(swiper) {
    swiper.value = swiper

    // console.log('onSwiper swiper.value', swiper.value)
  }
}

const containerWidth = ref(0)
const containerSized = ref(false)
const carouselcontainer = ref()

watch(containerWidth, (width) => {
  // console.log('containerWidth', width)
  containerSized.value = width > 0
}, {
  immediate: true
})

watch(carouselcontainer, () => {
  const { width } = useElementSize(carouselcontainer)
  watch(width, (newWidth) => {
    containerWidth.value = newWidth
  }, {
    immediate: true
  })
}, {
  immediate: true
})

// Expose Swiper reference
const swiperComponent = ref(null)

// Total number of products
const totalProducts = computed(() => $products.value.length)


function paginate(intent: 'next' | 'prev') {
  console.log("click")
  console.log('swiper', swiper.value)

  console.log('swiperComponent', swiperComponent.value)
  if (swiperComponent.value) {
    if (intent === 'prev') {

      console.log('swiperComponent.value?.swiper', swiperComponent.value?.swiper)
      swiperComponent.value.slidePrev()
    }


    if (intent === 'next') {
      console.log('swiperComponent.value?.swiper', swiperComponent.value?.swiper)
      swiperComponent.value.slideNext()
    }
  }
}

onMounted(() => {
  activeMenu.value = {
    slug: 'featured',
    label: 'Featured',
  }

  // Ensure products are populated before the component renders
  if (products.value.length > 0) {
    $products.value = products.value.slice(0, 3);
  }
})

const defultWidth = computed(() => vwWithMax(80, 1300) + "px");
</script>

<template>
  <Section id="mega-products" class="io-mega-popover sec-popover-container popover-media mega-products">
    <Section class="sec-mega-container" w="grid grid-cols-[360px_1fr] g-0">
      <Column class="column col-navigation" w="gp-1">
        <div class="sec-navigation flex flex-col g-0.5">
          <a
            v-for="item in MenuItems"
            :key="item.slug"
            :class="{ 'active': activeMenu.slug === item.slug }"
            @click="activeMenu = item"
            class="sec-nav-button"
          >
            <div class="wrap">
              <div class="icon flex items-start">
                <ISolveIcon />
              </div>
              <div class="sec-content">
                <div class="title">{{ item.label }}</div>
                <p class="description">{{ item.description }}</p>
              </div>
            </div>
          </a>
        </div>
        <div class="sec-actions">
          <div class="wrap flex justify-center gpt-1.5">
            <Button btn="blue" class="gpy-0.75 gpx-1.5 fs--1 fw-600 flex items-center g-0.5" @click="redirect('/products')">
              View All
            </Button>
          </div>
        </div>
      </Column>
      <Column class="column col-products" w="h-full text-red-500 gpt-1">
        <Section ref="carouselcontainer" class="max-w-92% mx-auto w-full h-full">
          <div :style="{ maxWidth: `${containerWidth}px` }" class="wrapper w-full">
            <client-only>
            <MpdSwiper
              v-if="containerSized"
              ref="swiperComponent"
              class="horizontal-carousel blogs-carousel"
              :options="{
                onSlideChange,
                onSwiper,
                slidesPerView: 'auto',
                spaceBetween: 0,
                pagination: true,
                navigation: true,
                loop: true,
                breakpoints: {
                  1600: { slidesPerView: 2, spaceBetween: 0 },
                  1366: { slidesPerView: 2, spaceBetween: 0 },
                  1200: { slidesPerView: 2, spaceBetween: 0 },
                  991: { slidesPerView: 2, spaceBetween: 0 },
                  600: { slidesPerView: 1, spaceBetween: 0 },
                }
              }"
              :slides="$products"
              :card-component="productCard"
            />
            </client-only>
          </div>
        </Section>
      </Column>
    </Section>
  </Section>
</template>

<style lang="scss" scoped>

#mega-products {
  width: v-bind(defultWidth);
}

.mega-products {
  .sec-mega-container {
    padding: gr(1);

    .btn-learn {
      color:white !important;
      .p-button-label {
        color: white !important;
      }
    }
  }

  .col-navigation {
    .sec-nav-button {
      cursor: pointer;
      padding: 10px;
      border-radius: 5px;
      transition: background 0.3s;
      text-decoration: none;

      &.active {
        /* background-color: #f0f0f0; */
      }

      .wrap {
        display: flex;
        align-items: center;

        .icon {
          margin-right: 10px;
        }

        .sec-content {
          .title {
            font-weight: bold;
          }

          .description {
            font-size: 0.9em;
            color: #666;
          }
        }
      }
    }
  }

  .col-products {

    :deep(.sec-mpd-swiper) {

      .swiper {

        cursor: grab;
        .swiper-pagination {
          position: relative;
        }

        .swiper-button-prev {

          transform: translateX(-50%);
          &:after {
            font-size: fs(1.5);
          }

          &:hover {
            &:after {
              color: var(--c-sky-blue);
              transform: translateY(-1px);
            }
            &:active {
              transform: translateX(-50%) translateY(0px);
              &:hover {
                transform: translateX(-50%) translateY(1px);
              }
            }
          }
        }

        .swiper-button-next {
          transform: translateX(50%);
          &:after {
            font-size: fs(1.5);
          }
          &:hover {
            &:after {
              color: var(--c-sky-blue);
              transform: translateY(-1px);
            }
            &:active {
              transform: translateX(50%) translateY(0px);
              &:hover {
                transform: translateX(50%) translateY(1px);
              }
            }
          }
        }
      }
    }

    .carousel-controls {
      .prev-button,
      .next-button {
        background-color: #007bff;
        color: #fff;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background-color: #0056b3;
        }
      }

      .pagination-dots {
        /* Swiper pagination is handled automatically */
      }
    }

    .total-products {
      font-size: 1em;
      color: #333;
    }
  }
}
</style>